import React                         from 'react';
import {connect}                     from 'react-redux';
import { Link }                      from 'react-router-dom';
import { ButtonToolbar,OverlayTrigger,Tooltip }                      from 'react-bootstrap';
import FlashCarregando               from '../../../container/FlashCarregando';
import EquipeProfessorTurmaAtiva      from './equipe_professor_turma_ativa';
import { GetListProfessorDisciplina,
         Dados_tur_dis,
         DesativarEquipes }           from '../../../actions/grupoAction';
import {SetError}                    from '../../../actions/authenticActions';
import { GetListaMenuTopo,
         GetListaSubMenuTopo,
         ActionModal,GetCheckSelect }               from '../../../actions/scopoAction';
     
class Equipe_Professor_Turma extends React.Component {

        constructor(props) {
              super(props);
              this.state = {
                              load   : false,
                              tur_id : this.props.match.params.tur_id,
                              dis_id : this.props.match.params.dis_id,
                              use_id : this.props.session.id,
                              conteudo_modal : null,
                              button1 :false,
                              button2 :false,
                              compartilhada:"",
                              tipo_lista : 1 // 1 - ativas / 2 - inativas

                            }
                            this.props.GetCheckSelect(null);


             this.props.Dados_tur_dis(this.state.tur_id,this.state.dis_id);               
        }

        componentWillMount(){

           
            
          this.props.GetListProfessorDisciplina(this.state.dis_id,this.state.tur_id).then((response) => {
             this.setState({load:true});
          }).catch((error) =>{
         //    this.props.SetError(500);
          });

          this.props.GetListaMenuTopo([
                                        {
                                         action:true,
                                         nome:"Home",
                                         link:this.props.menu.home
                                        },
                                        {
                                         action:true,
                                         nome:'Unidade Curricular',
                                         link:this.props.menu.equipe.professor.home
                                        },
                                        {
                                         action:false,
                                         nome:"Equipes"
                                        }
                                      ]);
            this.props.GetListaSubMenuTopo([
                                        {nome:"Ativa",link : null},
                                        {nome:"Inativa",link : 1},
                                      ]);
        }

        acaoEquipesRandomicas(){
            this.setState({ conteudo_modal: true });
            this.props.ActionModal(true);
        }

        acaoAddEquipe(){
            this.setState({ conteudo_modal: false });
            this.props.ActionModal(true);
        }

        acaoDesativarEquipes(){

            var flag = window.confirm('Deseja desativar todas as equipes?');

            if (!flag) {
                return false;
            }
         
            this.props.DesativarEquipes(this.state.dis_id).then(
                (response) =>{

                    //console.log(response)
                    // this.setState({
                    //     equ_id : response.payload.data.equ_id,
                    //     form   : 2,
                    //     load   : true,
                    //     equ_nome: response.payload.data.equ_nome
                    // });

                    //alert('Ação realizada com sucesso!');
                    //this.props.ActionModal(false);
                    //this.setState({listNomesEquipes:[]});

                }).catch((error) =>{
                this.props.SetError(500);
            });
        }
       
        render(){
            
              
                if (this.props.equipes_ativas) {
                  
                    var controleDesabled_1 = this.props.checkSelect === null ? false : true;
                    var controleDesabled_2 = (this.props.equipes_ativas.length>0 ? true  : false);
                    var controleDesabled_3 = this.props.checkSelect === null ? this.props.equipes_ativas.length===0?true:false : true;
                   
                }else{

                    var controleDesabled_1 = false ;
                    var controleDesabled_2 = false ;
                    var controleDesabled_3 = false ;
                }

                const lef = {'float':'left','paddingRight':'5px'}
                var compartilhada =  "";
                if (this.props.nome_disciplina) {

                   if (this.props.nome_disciplina.dis_compartilhada){
                    var ar = this.props.nome_disciplina.dis_compartilhada;
                    const popoverTop = (
                        <Tooltip id="tooltip">
                          <strong>Compartilhado com</strong>
                          <p></p>
                          {ar.map((elem,i)=>{
                           return <p key={i}>{elem}</p>
                          })} 
                        </Tooltip>
                      );

                      var compartilhada = <ButtonToolbar style={lef}>
                                            <OverlayTrigger placement="top" overlay={popoverTop}>
                                              <span className="glyphicon glyphicon-warning-sign btn btn-warning btn-xs"></span>
                                             </OverlayTrigger>
                                           </ButtonToolbar>;                   
                  } 

                  
                    
                }


              
          
                   return (
                            <div className="container-bg">
                                <div className="titulo-pages topo_conteudo">
                                    <div className="titulo">
                                    <strong style={lef}>{(this.props.nome_disciplina ? this.props.nome_disciplina.dis_nome:"")}</strong>
                                     {compartilhada}
                                     </div>
                                    
                                  
                                    <div className="botoes-topo-equipe">                                   

                                        <div>
                                            <button onClick={this.acaoDesativarEquipes.bind(this)} className="btn btn-danger btn-sm pull-right btn-space-left" disabled={controleDesabled_3}>
                                                <span className="glyphicon glyphicon-remove-circle"></span> desativar equipes
                                            </button>

                                            <button onClick={this.acaoAddEquipe.bind(this)} className="btn btn-success btn-sm pull-right btn-space-left" disabled={controleDesabled_1}>
                                                <span className="glyphicon glyphicon-plus"></span> adicionar equipe
                                            </button>                                          
                                        </div>

                                        <button onClick={this.acaoEquipesRandomicas.bind(this)} className="btn btn-sm btn-success pull-right btn-space-left" disabled={controleDesabled_2}>
                                            <span className="glyphicon glyphicon-transfer"></span> criar equipes
                                           </button>

                                            <Link to={this.props.menu.equipe.professor.home}>
                                                <button className="btn btn-default btn-sm pull-right">
                                                    <span className="glyphicon glyphicon-chevron-left"></span> voltar
                                                </button>
                                            </Link>

                                    </div>

                                </div>
                                {this.state.load ? <EquipeProfessorTurmaAtiva tipo_lista={this.props.checkSelect} funcao_modal={this.state.conteudo_modal}/> : <FlashCarregando/>}
                            </div>
                          );
                 }

}

function mapStateToProps(state){

        return {
               session         : state.auth.session,
               menu            : state.configReducer.menu,
               nome_turma      : state.equipeReducer.nome_turma,
               checkSelect     : state.scopoReducer.checkSelect,
               nome_disciplina : state.equipeReducer.nome_disciplina,
               equipes_ativas  : state.equipeReducer.all_equipes_ativas_professor,
               equipes_inativas: state.equipeReducer.all_equipes_inativas_professor
        };
  }

export default connect(mapStateToProps,{
                                        GetListProfessorDisciplina,
                                        DesativarEquipes,
                                        SetError,
                                        GetListaMenuTopo,
                                        GetListaSubMenuTopo,
                                        Dados_tur_dis,
                                        GetCheckSelect,
                                        ActionModal})(Equipe_Professor_Turma);




// WEBPACK FOOTER //
// ./src/components/professor/equipe/equipe_professor_turma.js